
export const LOGIN_ERROR = 'Login Failed: Incorrect email or password!';
export const PASSWORD_REQUIREMENT_TEXT = `Password should contain 8 to 16 characters and must combine uppercase and lowercase letters, numbers, and special characters(i.e. @#$%^&<>;:-).`;

export const UNSAVED_CHANGES_CONFIRM_TEXT = "It looks like you haven't saved your changes, are you sure you want to leave?";
export const CONFIRM_TEXT = "Are you sure you want to leave?";
export const UNSAVED_AUDIO_CONFIRM_TEXT = "You have dictation audio that has not been parked or submitted for typing. If you leave, it will be discarded.";
export const LOGOUT_CONFIRM_TEXT = "Visit is locked, are you sure you want to logout?";

export const MISSING_INFO_WARNING = "Warning: The report contain double question marks (??),indicating uncertainty or missing information.Please review and confirm missing or unclear information promptly";
